import {StorageExecutor} from 'app/rgs/utils';

export default class LkTypeStorageExecutor extends StorageExecutor {
	static Key = 'lk-type-storage-executor';
	lkTypeKey = 'lkType';
	lkCompanyKey = 'lkCompanyKey';

	constructor () {
		super();

		this.registerNamespace(
			LkTypeStorageExecutor.Key
		);
	}
    
	setLkType (lkType) {
		this.set(this.lkTypeKey, lkType);
	}

	setLkCompany (lkCompany) {
		this.set(this.lkCompanyKey, lkCompany);
	}

	getLkType () {
		return this.get(this.lkTypeKey);
	}

	getLkCompany () {
		return this.get(this.lkCompanyKey);
	}

	clear () {
		this.setLkCompany(null);
		this.setLkType(null);
	}
}